// datatable related plugins
import Breadcrumbs from "components/Common/Breadcrumb";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  REGISTRY_INVOICE_FIELD,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { formConvertErrorMessage } from "helpers/form_helper";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import React, { useEffect, useState } from "react";
import {
  customFilter,
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Button, Card, CardBody, Col, Row } from "reactstrap";
import {
  deleteCustomerInvoice,
  getListCustomerInvoice,
  resetCreateCustomerInvoice,
  resetDeleteCustomerInvoice,
  resetEditCustomerInvoice,
  resetListCustomerInvoice,
  setColumnVisibleCustomerInvoice,
} from "store/general-info/customer/actions";
import {
  CREATE_CUSTOMER_INVOICE_FAIL,
  CREATE_CUSTOMER_INVOICE_SUCCESS,
  DELETE_CUSTOMER_INVOICE_FAIL,
  DELETE_CUSTOMER_INVOICE_SUCCESS,
  EDIT_CUSTOMER_INVOICE_FAIL,
  EDIT_CUSTOMER_INVOICE_SUCCESS,
} from "store/general-info/customer/actionTypes";
import DetailData from "./DetailData";
import { getStatus } from "./helper/functionHelper";
import { modeDetail } from "./utils";

const ListData = props => {
  const [mode, setMode] = useState(null);
  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const toggleViewDetailModal = () => setModalDetail(!modalDetail);

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  const [idDetail, setIdDetail] = useState(null);
  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);
  // store reducer
  const customerInvoice = useSelector(state => state.customerInvoice);
  const { loading, listData, totalCount, columnsVisible, params } =
    customerInvoice.customer;
  const history = useHistory();

  const { t, i18n } = useTranslation(["customer"]);

  const [commonStatus, setCommonStatus] = useState(getStatus(t));

  useEffect(() => {
    setCommonStatus(getStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  useEffect(() => {
    switch (customerInvoice.type) {
      case CREATE_CUSTOMER_INVOICE_SUCCESS:
        addToast(
          t("message.create", {
            target: t("customer"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleViewDetailModal();
        dispatch(getListCustomerInvoice(params));
        dispatch(resetCreateCustomerInvoice());
        break;
      case CREATE_CUSTOMER_INVOICE_FAIL:
        if (
          customerInvoice.createCustomer.error.code === 422 &&
          customerInvoice.createCustomer.error.fields.length > 0
        ) {
          customerInvoice.createCustomer.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.create", {
                      target: t("customer"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`form.${item.field}`) + " không hợp lệ."
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetCreateCustomerInvoice());
        break;

      case EDIT_CUSTOMER_INVOICE_SUCCESS:
        addToast(
          t("message.update", {
            target: t("customer"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleViewDetailModal();
        dispatch(getListCustomerInvoice(params));
        dispatch(resetEditCustomerInvoice());
        break;
      case EDIT_CUSTOMER_INVOICE_FAIL:
        if (
          customerInvoice.editCustomer.error.code === 422 &&
          customerInvoice.editCustomer.error.fields.length > 0
        ) {
          customerInvoice.editCustomer.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.update", {
                      target: t("customer"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`form.${item.field}`) + " không hợp lệ."
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetEditCustomerInvoice());
        break;

      case DELETE_CUSTOMER_INVOICE_SUCCESS:
        addToast(
          t("message.delete", {
            target: t("customer"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleConfirmDeleteModal();
        dispatch(getListCustomerInvoice(params));
        dispatch(resetDeleteCustomerInvoice());
        break;
      case DELETE_CUSTOMER_INVOICE_FAIL:
        addToast(
          t("message.delete", {
            target: t("customer"),
            status: t("message.error"),
          }),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        dispatch(resetDeleteCustomerInvoice());
        break;
      default:
        break;
    }
  }, [customerInvoice.type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (tenantCodeHeader) {
      //   params.page = 1;
      dispatch(getListCustomerInvoice(params));
    }
  }, [tenantCodeHeader]);

  useEffect(() => {
    if (customerInvoice.listVat) {
      initColumn();
    }
  }, [customerInvoice.listVat]);

  useEffect(() => {
    return () => {
      dispatch(resetListCustomerInvoice());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail(row);
      setMode(modeDetail.VIEW);
      toggleViewDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="bx bx-edit font-size-18 text-success" />,
      text: "Cập nhật",
      onClick: row => {
        setDataDetail(row);
        setMode(modeDetail.EDIT);
        toggleViewDetailModal();
      },
    },
    {
      icon: <i className="bx bx-trash font-size-18 text-danger" />,
      text: "Xóa",
      onClick: row => {
        setIdDetail(row.id);
        toggleConfirmDeleteModal();
      },
    },
  ];

  const OPTION_HTHUC = [
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD,
      label: t("select.hthuc_add"),
    },
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT,
      label: t("select.hthuc_edit"),
    },
  ];

  const selectFilterHTHUC = {
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD]:
      t("select.hthuc_add"),
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT]:
      t("select.hthuc_edit"),
  };

  //   const getAuthStatus = (status, id) => {
  //     let infoError = null;
  //     if (
  //       status === AUTH_STATUS_REJECT ||
  //       status === AUTH_STATUS_RRE ||
  //       status === AUTH_STATUS_RR
  //     ) {
  //       infoError = (
  //         <i
  //           style={{ cursor: "pointer" }}
  //           title="Hiển thị lý do từ chối"
  //           className="font-size-17 bx bx-info-circle text-danger"
  //           onClick={() => {
  //             setIdRelease(id);
  //             toggleErrorReleaseModal();
  //           }}
  //         ></i>
  //       );
  //     }
  //     return (
  //       <React.Fragment>
  //         <div className="d-flex gap-1">
  //           <Badge
  //             className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
  //             pill
  //           >
  //             {commonStatus?.AUTH_STATUS[status]?.text}
  //           </Badge>
  //           {infoError}
  //         </div>
  //       </React.Fragment>
  //     );
  //   };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Đang xử lý",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Hoàn tất",
  };

  const selectTypeId = {
    1: "Doanh nghiệp",
    2: "Khách lẻ",
  };

  const initColumns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "ma",
      text: t("form.ma"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "ten",
      text: t("form.ten"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "type_id",
      text: t("form.type_id"),
      filter: selectFilter({
        placeholder: t("placeholder.select"),
        options: selectTypeId,
      }),
      formatter: (cellContent, row) => {
        return selectTypeId[cellContent];
      },
    },
    {
      dataField: "idno",
      text: t("form.idno"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "mst",
      text: t("form.mst"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "cty",
      text: t("form.cty"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "stknhang",
      text: t("form.stknhang"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "tnhang",
      text: t("form.tnhang"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "dchi",
      text: t("form.dchi"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      hidden: true,
    },
    {
      dataField: "sdthoai",
      text: t("form.sdthoai"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      hidden: true,
    },
    {
      dataField: "dctdtu",
      text: t("form.dctdtu"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
      hidden: true,
    },
    {
      dataField: "fax",
      text: t("form.fax"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "checker_date",
      text: "Ngày cập nhật",
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getListCustomerInvoice(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getListCustomerInvoice(params));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleCustomerInvoice(field, value));
  };

  const resetDataFunc = () => {
    dispatch(getListCustomerInvoice(params));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách khách hàng</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={"Danh sách khách hàng" + ` (${totalCount})`}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <ConfirmModal
                      isOpen={modalConfirmDelete}
                      titleHeader={"Xác nhận xóa khách hàng"}
                      titleBody={"Hệ thống sẽ thực hiện xóa khách hàng này ?"}
                      isDisableButton={customerInvoice.deleteCustomer.loading}
                      onConfirm={note => {
                        dispatch(deleteCustomerInvoice(idDetail));
                      }}
                      textBtnConfirm={"Xác nhận"}
                      textBtnCancel={"Đóng"}
                      toggle={toggleConfirmDeleteModal}
                    />
                    <DetailData
                      dataDetail={dataDetail}
                      isOpenModal={modalDetail}
                      toggleModal={toggleViewDetailModal}
                      mode={mode}
                    />
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          setDataDetail(null);
                          setMode(modeDetail.CREATE);
                          toggleViewDetailModal();
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        Thêm mới
                      </Button>
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
